import { Tooltip, IconButton } from '@mui/material';

const STooltip = ({ title, icon, onClick, disabled }) => {
	return (
		<section>
			<Tooltip arrow title={title}>
				<span>
					<IconButton disabled={disabled} onClick={onClick}>
						{icon}
					</IconButton>
				</span>
			</Tooltip>
		</section>
	);
};

export default STooltip;
